<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Dedicated</span></p>
<p class="P_WFP_Quote__And__Centre_Alignment__And__Left_Indent"><span>to all the many sincere and objective newspapermen</span></p>
<p class="P_WFP_Quote__And__Centre_Alignment__And__Left_Indent"><span>and -women, in Washington and elsewhere,</span></p>
<p class="P_WFP_Quote__And__Centre_Alignment__And__Left_Indent"><span>who are not part of</span></p>
<p class="P_WFP_Quote__And__Centre_Alignment__And__Left_Indent"><span>Walter’s world.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?0b7a8569